import * as Config from '../../../../../config';

const useCustomGenres = (track, isEnabled) => {

  let storeDD = JSON.parse(localStorage.getItem('dd'));
  if (!storeDD) {
    storeDD = [];
    localStorage.setItem('dd', JSON.stringify(storeDD))
  }

  const categories = ['Best New Independent Artist', 'Best New Hype', 'Best New', /*'Best Of Hype', 'Best Of',*/ 'Shortlist', /*'Warm Up Essentials',*/ 'Dancefloor Essentials', 'Closing Essentials', 'After Hour Essentials', 'Crate Diggers', 'Secret Weapons'];
  const formatTitle = (x) => {
    let lock = false;
    x.name = categories.reduce((base,cat) => {
      if (x.name.toLowerCase().includes(cat.toLowerCase()) && !lock) {
        base = cat;
        lock = true;
      }
      return base;
    }, x.name)
    return x;
  }

  const getMainGenre = (genres, slug) => {
    let max = 0;
    return genres.reduce((base, g, i) => {
      let words = g.slug.split('-');
      const extra = Config.GENRES_CUSTOM_EXTRA_SEARCH_SLUG.find( e => e.id === g.id );
      if (extra && extra.words) {
        words = [...words, ...extra.words];
      }
      let count = 0;
      words.forEach( word => { count += (slug.includes(word)) ? 1 : 0 })
      if ((count > max) || (count === words.length && count >= max)) {
        max = count;
        return g;
      } else {
        return base;
      }
    }, null);
  }

  const isUpdated = (name, dateUpdated) => {
    const item = storeDD.find( x => x.n === name );
    if (!item) { // Initialization when visible and no existing
      storeDD.push({n: name, u: dateUpdated});
      localStorage.setItem('dd', JSON.stringify(storeDD))
    }
    return (item && item.u !== dateUpdated)
  }

  return { formatTitle, getMainGenre, isUpdated };
};

export default useCustomGenres;
